import { useEffect } from 'react';
import ScreenService from '../services/screen-service';

const useResize: Function = (onResize: Function): void => {
  const RESIZE_DELAY: number = 100;

  const resize: ReactEventListener = ScreenService.withDelay((): void => {
    if (onResize) {
      onResize();
    }
  }, RESIZE_DELAY);

  useEffect((): ReactUseEffectCleanUp => {
    ScreenService.addEventListener('resize', resize);

    return (): void => {
      ScreenService.removeEventListener('resize', resize);
    };
  }, []);
};

export default useResize;
